// extracted by mini-css-extract-plugin
export var highlight = "highlight-text-module--highlight--1_1hq";
export var searchContainer = "highlight-text-module--search-container--U_WKr";